export enum BoardPositionEnum {
  President = 'President',
  Secretary = 'Secretary',
  Treasurer = 'Treasurer',
  CEO = 'CEO',
  CFO = 'CFO',
  Manager = 'Manager',
  BankSignatory = 'BankSignatory',
}

export enum Gender {
  Male = 'Male',
  Female = 'Female',
  Other = 'Other',
}
